var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('black-list-user-form',{attrs:{"loading":_vm.loading,"user":_vm.user,"blackListUserData":_vm.blackListUser,"formErrors":_vm.formErrors},on:{"blackListUserSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }